import { ref } from 'vue';
import { reportClientError, ErrorLocation } from '@/telemetry/errors';

const STORAGE_KEY_SEEN = 'lexicontest_tutorial_seen';

function readSeen(): boolean {
  try {
    return localStorage.getItem(STORAGE_KEY_SEEN) === 'true';
  } catch {
    return false;
  }
}

// Module-level singleton state
const _hasSeen = ref(readSeen());

const _codexOpen = ref(false);
const _briefingOpen = ref(false);

export function useTutorialState() {
  const hasSeen = _hasSeen as Readonly<typeof _hasSeen>;

  function markSeen(): void {
    _hasSeen.value = true;
    try {
      localStorage.setItem(STORAGE_KEY_SEEN, 'true');
    } catch (e) {
      reportClientError(e, ErrorLocation.TutorialStatePersist);
    }
  }

  const codexOpen = _codexOpen as Readonly<typeof _codexOpen>;
  function openCodex(): void {
    _codexOpen.value = true;
  }
  function closeCodex(): void {
    _codexOpen.value = false;
  }

  const briefingOpen = _briefingOpen as Readonly<typeof _briefingOpen>;
  function openBriefing(): void {
    _briefingOpen.value = true;
  }
  function closeBriefing(): void {
    _briefingOpen.value = false;
  }

  return {
    hasSeen,
    markSeen,
    codexOpen,
    openCodex,
    closeCodex,
    briefingOpen,
    openBriefing,
    closeBriefing,
  };
}
